import { Button, Text, ViewEvaluationIcon } from '@viapeople/components'
import { useNavigate, useParams } from 'react-router-dom'
import { type Column, GenericTable } from '../../../../admin/src/components/GenericTable'

import { formatStepName } from '../../utils/helpers'
import { trpc } from '../../utils/trpc'
import type { SearchEvaluationAsViewer, SearchEvaluationAsViewerInput } from './types'

type Columns = Column<SearchEvaluationAsViewer>[]

export function SearchEvaluationAsViewerPage() {
	const navigate = useNavigate()
	const { cycleId } = useParams()

	const columns: Columns = [
		{
			field: 'firstName',
			label: 'First Name',
			colSpan: 2,
			render: (evaluation: SearchEvaluationAsViewer) => (
				<Text variant='xsmall' weight='regular' className='group-hover:text-primary-600'>
					{evaluation.firstName}
				</Text>
			),
		},
		{
			field: 'lastName',
			label: 'Last Name',
			colSpan: 2,
			render: (evaluation: SearchEvaluationAsViewer) => (
				<Text variant='xsmall' weight='regular' className='group-hover:text-primary-600'>
					{evaluation.lastName}
				</Text>
			),
		},
		{
			field: 'reviewerCount',
			label: 'Raters',
			colSpan: 1,
			render: (evaluation: SearchEvaluationAsViewer) => (
				<Text variant='xsmall' weight='regular' className='group-hover:text-primary-600'>
					{evaluation.reviewerCount}
				</Text>
			),
		},
		{
			field: 'currentSteps',
			label: 'Status',
			colSpan: 1,
			render: (evaluation: SearchEvaluationAsViewer) => (
				<Text variant='xsmall' weight='regular' className='group-hover:text-primary-600'>
					{evaluation.currentSteps.map(formatStepName).join(', ')}
				</Text>
			),
		},
	]

	return (
		<main className='w-full p-6'>
			<div className='mb-6'>
				<Text variant='h3' weight='semibold'>
					Search Evaluation
				</Text>
				<Button variant={'tertiary'} onClick={() => navigate('/dashboard')}>
					&lt; Back to dashboard
				</Button>
			</div>

			<div className='border border-neutral-200 bg-neutral-0 rounded-lg shadow-xl'>
				<GenericTable<SearchEvaluationAsViewer, SearchEvaluationAsViewerInput>
					columns={columns}
					idField='evaluationId'
					queryOptionsGenerator={(options) => ({
						...trpc.client.viewers.search.queryOptions({
							...options,
							cycleId: cycleId || '',
						}),
					})}
					onRowClick={(evaluation) => {
						navigate(`/cycle/${cycleId}/cycle-view/${evaluation.evaluationId}`)
					}}
					showSearch
					showPagination
					emptyState={{
						icon: ViewEvaluationIcon,
						title: 'No evaluations found',
					}}
				/>
			</div>
		</main>
	)
}
